import { useEffect, useState } from "react";
import {

    DesignTokens,
    Row,
    Col,
    RangePicker,

} from "melco-ui";

import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash-es";
import styled from "styled-components";
import { AllProductsGeneralSelect } from "../common/AllProductsGeneralSelect";
import { subMonths } from "date-fns";
import dayjs from "dayjs";

const { spacings } = DesignTokens;

export type DashboardFiltersType = {


    selectedProductCode?: string;
    startTimeStamp?: Date;
    endTimeStamp?: Date;
};

type DashboardFilterProps = {
    onFiltersChange: (filters: DashboardFiltersType | undefined) => void;
};


export const DashboardFilter: React.FC<DashboardFilterProps> = ({
    onFiltersChange,
}) => {
    const { t } = useTranslation();

    const now = new Date();
    const oneMonthBeforeTimeStamp = subMonths(now, 1);
    console.log("oneMonthBeforDateTime ", oneMonthBeforeTimeStamp);
    const defaultStartTimestamp = dayjs(oneMonthBeforeTimeStamp).startOf("day").toDate();
    console.log("defaultStartTimeStamp ", defaultStartTimestamp);
    const defaultEndTimestamp = dayjs(now).endOf("day").toDate();
    console.log("defaultEndTimestamp ", defaultEndTimestamp);

    //const format = getDateFormatString(navigator.language);
    const [dashboardFilter, setDashboardFilter] = useState<
        DashboardFiltersType | undefined
    >({
        startTimeStamp: defaultStartTimestamp,
        endTimeStamp: defaultEndTimestamp

    });



    useEffect(() => {
        //console.log({ dashboardFilter })
        onFiltersChange(dashboardFilter);
    }, [dashboardFilter, onFiltersChange]);



    const BoxWrapper = styled.div`
    max-width: 300px;
    min-width: 225px;
`;




    return (<div>
        <Row gutter={[spacings.middle, spacings.middle]}>


            <Col  >
                <AllProductsGeneralSelect
                    //mode={undefined}
                    onChange={(value: any) => {
                        setDashboardFilter((prevFilter: any) => {
                            return {
                                ...prevFilter,
                                selectedProductCode: !isEmpty(value) ? value : undefined,
                            };
                        });
                    }}
                    value={dashboardFilter?.selectedProductCode ?? undefined}

                />
            </Col>
            <Col >
                <BoxWrapper>
                    <RangePicker
                        format="L"

                        defaultValue={[dayjs(defaultStartTimestamp), dayjs(defaultEndTimestamp)]}
                        //    disabledDate={(v) => isFuture(v.toDate())}
                        onChange={(value) => {
                            const startTimeStamp =
                                (value && value[0] && value[0].startOf("day").toDate()) ??
                                undefined;
                            const endTimeStamp =
                                (value && value[1] && value[1].endOf("day").toDate()) ??
                                undefined;

                            setDashboardFilter((prevFilter: any) => {
                                return {
                                    ...prevFilter,
                                    startTimeStamp,
                                    endTimeStamp,
                                };
                            });
                        }}
                        value={
                            dashboardFilter?.startTimeStamp &&
                            dashboardFilter?.endTimeStamp && [
                                dayjs(dashboardFilter?.startTimeStamp),
                                dayjs(dashboardFilter?.endTimeStamp),
                            ]
                        }
                        placeholder={[
                            t("dashboard.wizards.filter.start_timestamp.placeholder"),
                            t("dashboard.wizards.filter.end_timestamp.placeholder"),
                        ]}

                    />
                </BoxWrapper>
            </Col>





        </Row>
    </div>
    );
};
